import React from 'react';

import styles from './styles.module.scss';

export const Button = ({text, icon, onClick, type, href, target}) => {
  return (
    <>
      {!href ? (
        <button className={styles.button} onClick={onClick} type={type}>
          {text && text}
          {icon && icon}
        </button>
      ) : (
        <a className={styles.button} href={href} target={target}>
          {text && text}
          {icon && icon}
        </a>
      )}
    </>
  );
};
